import * as Yup from 'yup';

export const membershipSchema = Yup.object({
    group_id: Yup.string().required('Group Name is a required field'),
}).required();
